/* ZSportsTech — section-nav.js (Shopify)
   Global nav-header behaviour. Ported from the static build's include.js initNav()
   so the active tab, solid-from-top (data-nav-solid) vs transparent-on-scroll, and
   the mobile drawer all match the static design exactly. Vanilla JS, scoped to #sc-nav.
   ─────────────────────────────────────────────────── */
(function () {
  'use strict';

  function initNav() {
    var nav = document.getElementById('sc-nav');
    if (!nav) return;
    var body = document.body;
    var page = body.getAttribute('data-page') || '';
    var solid = body.hasAttribute('data-nav-solid');

    /* active tab + drawer link, from <body data-page> */
    if (page) {
      var matches = nav.querySelectorAll('[data-nav="' + page + '"]');
      Array.prototype.forEach.call(matches, function (a) {
        if (a.classList.contains('sc-nav__tab')) a.classList.add('sc-nav__tab--active');
        if (a.classList.contains('sc-nav__drawer-link')) a.classList.add('sc-nav__drawer-link--active');
        a.setAttribute('aria-current', 'page');
      });
    }

    /* solid-from-top (white pages) vs transparent → solid on scroll */
    if (solid) {
      nav.classList.add('sc-nav--solid');
    } else {
      var onScroll = function () { nav.classList.toggle('sc-nav--solid', window.scrollY > 20); };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }

    /* mobile drawer */
    var toggle = document.getElementById('sc-nav-toggle');
    var drawer = document.getElementById('sc-nav-drawer');
    if (toggle && drawer) {
      toggle.addEventListener('click', function () {
        var open = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', String(!open));
        drawer.classList.toggle('sc-nav__drawer--open', !open);
      });
      document.addEventListener('click', function (e) {
        if (!nav.contains(e.target)) {
          toggle.setAttribute('aria-expanded', 'false');
          drawer.classList.remove('sc-nav__drawer--open');
        }
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          toggle.setAttribute('aria-expanded', 'false');
          drawer.classList.remove('sc-nav__drawer--open');
          toggle.focus();
        }
      });

      /* collapsible groups inside the drawer (Products, Net Sessions) */
      Array.prototype.forEach.call(drawer.querySelectorAll('.sc-nav__drawer-toggle'), function (btn) {
        btn.addEventListener('click', function () {
          var open = btn.getAttribute('aria-expanded') === 'true';
          /* close any other open group first — one open at a time */
          Array.prototype.forEach.call(drawer.querySelectorAll('.sc-nav__drawer-toggle'), function (other) {
            other.setAttribute('aria-expanded', 'false');
            var os = other.nextElementSibling;
            if (os) os.classList.remove('sc-nav__drawer-sub--open');
          });
          if (!open) {
            btn.setAttribute('aria-expanded', 'true');
            var sub = btn.nextElementSibling;
            if (sub) sub.classList.add('sc-nav__drawer-sub--open');
          }
        });
      });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initNav);
  else initNav();
}());
